.notification {
    border-radius: var(--border-radius);
    display: flex;
    align-items: center;
    gap: 8px;
    color: var(--white);
    padding: 12px 16px;
}

.success {
    background-color: var(--lime);
}

.error {
    background-color: var(--red);
}

.enter {
    animation: notificationEnter 0.5s ease;
}

.exit {
    animation: notificationExit 1s ease;
}

@keyframes notificationEnter {
    0% {
        transform: translateX(-100%);
        opacity: 0;
    }
    100% {
        transform: translateX(0%);
        opacity: 1;
    }
}

@keyframes notificationExit {
    0% {
        transform: translateX(0%);
        opacity: 1;
    }
    100% {
        transform: translateX(-100%);
        opacity: 0;
    }
}
